export default "__VITE_ASSET__DocbSjE2__"